
import React, {useContext, useEffect, useRef, useState} from "react";
import { useIntl } from "react-intl";
import { Box, Grow, Fade, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, Collapse, IconButton, Typography } from "@mui/material";
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import robotIcon from './robotIcon.svg';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import PublicIcon from '@mui/icons-material/Public';
import BoltIcon from '@mui/icons-material/Bolt';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import uploadSvg from './upload.svg'
import useChatLocalState from "../../../hooks/openAI/useChatLocalState";
import { AuthContext } from "../../../contexts/auth";
import MyButton from "../../myButton";
import MyLabel from "../../myLabel";
import MyPanelHelp from "../../myPanelHelp";
import MyInput from "../../myInput";

import SavedChatsSelect from "./savedChatsSelect";

import { style } from "./styles";
import MyImage from "../../myImage";
import { array } from "prop-types";

function MessageDialog({open, name, handleClose, handleSuccess}) {
  
    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            PaperProps={{
                sx: {
                    borderRadius: '20px',
                    maxWidth: '380px',
                    width: '100%',
                }
            }}
        >
            <DialogTitle sx={{ fontWeight: 600, fontSize: '18px', paddingBottom: '8px', textAlign: 'center' }}>
                Salva conversazione
            </DialogTitle>
            <DialogContent>
                <Typography sx={{ color: '#666', fontSize: '14px', textAlign: 'center', marginBottom: '16px' }}>
                    Inserisci un nome per salvare questa chat
                </Typography>
                <MyInput 
                    type='text'
                    size='small'
                    id='name'
                    label='Nome chat'
                    required={true}
                    value={name.value}
                    onChange={(e)=>name.set(e.target.value)}
                    sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                        }
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ padding: '16px 24px', gap: '8px' }}>
                <MyButton 
                    onClick={handleClose}
                    text='Annulla'
                    variant="outlined" 
                    size="small"
                    sx={{
                        borderRadius: '12px',
                        borderColor: '#ccc',
                        color: '#666',
                    }}
                />
                <MyButton 
                    onClick={()=> {handleSuccess(); handleClose()}}
                    text='Salva'
                    variant="contained" 
                    size="small"
                    sx={{
                        backgroundColor: '#00a271',
                        borderRadius: '12px',
                        ':hover': {
                            backgroundColor: '#11B382',
                        },
                    }}
                />
            </DialogActions>
        </Dialog>
    )
}

const MessageArea = ({message, handleRemove, last }) =>{

    const isUser = message.role === 'user';
    return (
        <Grow  in={true} timeout={ last ? 600 : 0} >
            <Box sx={{...style.messageArea, backgroundColor: isUser ? '#ebebeb' : '#FFF'}}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems:'center',
                    alignContent: 'center',
                    marginBottom: '10px',
                }}>
                    <Box sx={{...style.messageTitleArea, justifyContent: isUser ? 'end' : 'start'}}>
                        <MyLabel component='p' text={isUser ? 'YOU' : 'AI'} 
                        sx={{...style.title, color: isUser ? '#666670' : '#00a271'}} />
                    </Box>
                    <Box  sx={{
                        display: 'flex',
                        alignItems:'center',
                        alignContent: 'center',
                        }}>
                        <RemoveCircleOutlineIcon onClick={() => handleRemove(message)} sx={{ color: '#a3a3a3', cursor: 'pointer' }} />
                    </Box>
                </Box>
                <Box>
                    {
                        message.content[0]?.type === 'text' ?
                            message.content?.map((item, key)=>{
                                return (
                                    <Box>
                                        {item.type === 'text'? <MyLabel component='p' text={item.text} sx={{wordWrap: 'break-word', whiteSpace: 'break-spaces'}} noTranslate={true} /> : <></>}
                                        {item.type === 'image_url'? <MyImage src={item.image_url.url} sx={{width:'80px', height:'80px'}}  /> : <></>}
                                    </Box>
                                    )

                                }

                            )
                        
                        :
                            <MyLabel component='p' text={message.content} sx={{wordWrap: 'break-word', whiteSpace: 'break-spaces'}} noTranslate={true} />
                        
                    }
                </Box>

            </Box>
        </Grow >
    )
}

function Chat({ updateHistoric }) {

    let intl = useIntl();
    const isMobile = window.innerWidth < 600;
    const { historic } = useContext(AuthContext);
    const bottomOfMessages = useRef(null);
    const systemTextArea = useRef(null);
    const sendTextArea = useRef(null);
    const returnTextArea = useRef(null);
    const [dialogOpen, setDialogOpen] = useState(false)
    const [identityExpanded, setIdentityExpanded] = useState(false)
    const [selectedIdentity, setSelectedIdentity] = useState(null)
    const [isCreatingNew, setIsCreatingNew] = useState(false)
    const [editingIdentity, setEditingIdentity] = useState(null)
    
    const [savedIdentities, setSavedIdentities] = useState([
        { 
            id: 0, 
            name: 'Assistente Marketing', 
            prompt: 'Sei un esperto di marketing digitale e comunicazione. Aiuti a creare contenuti pubblicitari persuasivi, strategie di social media, copy per annunci e campagne marketing. Sei creativo, orientato ai risultati e conosci le ultime tendenze del settore.',
            isDefault: true
        }
    ])
    const [selectedModel, setSelectedModel] = useState(0)
    const [isScrolledDown, setIsScrolledDown] = useState(false)
    const modelButtonsRef = useRef(null)

    const [identityModalOpen, setIdentityModalOpen] = useState(false)
    const [identityModalMode, setIdentityModalMode] = useState('create')
    const [identityModalName, setIdentityModalName] = useState('')
    const [identityModalPrompt, setIdentityModalPrompt] = useState('')

    const [confirmChatChangeOpen, setConfirmChatChangeOpen] = useState(false)
    const [pendingIdentityChange, setPendingIdentityChange] = useState(null)
    
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [deleteConfirmIdentityId, setDeleteConfirmIdentityId] = useState(null)
    
    const [upgradeModalOpen, setUpgradeModalOpen] = useState(false)
    
    const userPlan = 'base';
    const planLimits = {
        base: 3,
        pro: 10,
        max: Infinity
    };

    const aiModels = [
        { id: 0, name: 'GPT 5.2', subtitle: 'SEARCH WEB', color: '#00a271', icon: SearchIcon },
        { id: 1, name: 'AI Perplexity', subtitle: 'DEEP SEARCH', color: '#4A90D9', icon: PublicIcon },
        { id: 2, name: 'GPT 5 mini', subtitle: 'FREE', color: '#721384', icon: BoltIcon },
    ]

    const openIdentityModal = (mode, identity = null) => {
        if (mode === 'create' && savedIdentities.length >= planLimits[userPlan]) {
            setUpgradeModalOpen(true);
            return;
        }
        setIdentityModalMode(mode);
        if (mode === 'edit' && identity) {
            setIdentityModalName(identity.name);
            setIdentityModalPrompt(identity.prompt);
            setEditingIdentity(identity.id);
        } else {
            setIdentityModalName('');
            setIdentityModalPrompt('');
            setEditingIdentity(null);
        }
        setIdentityModalOpen(true);
    }

    const handleIdentityModalSave = () => {
        const name = identityModalName.trim() || 'Nuova Identità';
        const prompt = identityModalPrompt;
        
        if (identityModalMode === 'edit' && editingIdentity !== null) {
            setSavedIdentities(prev => prev.map(i => 
                i.id === editingIdentity ? { ...i, name, prompt } : i
            ));
        } else {
            const newId = Math.max(...savedIdentities.map(i => i.id), 0) + 1;
            setSavedIdentities(prev => [...prev, { id: newId, name, prompt }]);
            setSelectedIdentity(newId);
            action.system.set(prompt);
        }
        setIdentityModalOpen(false);
        setEditingIdentity(null);
    }

    const handleDeleteIdentity = (identityId) => {
        setDeleteConfirmIdentityId(identityId);
        setDeleteConfirmOpen(true);
    }
    
    const confirmDeleteIdentity = () => {
        const identityId = deleteConfirmIdentityId;
        setSavedIdentities(prev => prev.filter(i => i.id !== identityId));
        if (selectedIdentity === identityId && savedIdentities.length > 1) {
            const remaining = savedIdentities.filter(i => i.id !== identityId);
            setSelectedIdentity(remaining[0]?.id || null);
            action.system.set(remaining[0]?.prompt || '');
        }
        setDeleteConfirmOpen(false);
        setDeleteConfirmIdentityId(null);
    }
    
    const hasUnsavedConversation = () => {
        return action.talk.value && action.talk.value.length > 0;
    }
    
    const handleStartChat = (identity) => {
        if (hasUnsavedConversation()) {
            setPendingIdentityChange(identity);
            setConfirmChatChangeOpen(true);
        } else {
            setSelectedIdentity(identity.id);
            action.system.set(identity.prompt);
            setIdentityExpanded(false);
            setTimeout(() => sendTextArea.current?.focus(), 300);
        }
    }
    
    const confirmStartNewChat = () => {
        if (pendingIdentityChange) {
            action.talk.set([]);
            action.returnText.set('');
            setSelectedIdentity(pendingIdentityChange.id);
            action.system.set(pendingIdentityChange.prompt);
            setIdentityExpanded(false);
            setTimeout(() => sendTextArea.current?.focus(), 300);
        }
        setConfirmChatChangeOpen(false);
        setPendingIdentityChange(null);
    }
    
    const handleSaveAndStartNewChat = () => {
        setConfirmChatChangeOpen(false);
        setDialogOpen(true);
    }

    useEffect(() => {
        const messagesContainer = bottomOfMessages.current;
        if (!messagesContainer) return;
        
        const handleScroll = () => {
            const scrollTop = messagesContainer.scrollTop;
            setIsScrolledDown(scrollTop > 50);
        };
        
        messagesContainer.addEventListener('scroll', handleScroll);
        return () => messagesContainer.removeEventListener('scroll', handleScroll);
    }, []);

    const [returnTextAreaFocus, setReturnTextAreaFocus] = useState(false)

    const onFocusReturnText = () => setReturnTextAreaFocus(true)
    const onBlurReturnText = () => setReturnTextAreaFocus(false)

    const [sendTextAreaFocus, setSendTextAreaFocus] = useState(false)

    const onFocusSendText = () => setSendTextAreaFocus(true)
    const onBlurSendText = () => setSendTextAreaFocus(false)

    const [systemTextAreaFocus, setSystemTextAreaFocus] = useState(false)

    const onFocusSystemText = () => setSystemTextAreaFocus(true)
    const onBlurSystemText = () => setSystemTextAreaFocus(false)

    const [help, setHelp] = useState({
        title: "Shape Your Chatbot's Identity",
        type: 1,
        open: false,
        top: 250,
        left: 500
    });

    const action = useChatLocalState(updateHistoric);

    const handlerCancel = ()=>{
        action.cancel.set(false)
    }

    useEffect(() => {
        action.getSaveChat.set()
    }, []);

    useEffect(() => {
        if (historic.value){
            action.sendText.set(historic.value.text);
            historic.set(null)
        }
    }, [historic.value]);

    useEffect(() => {

        if (returnTextArea.current){
            returnTextArea.current.style.height = '80px';
            returnTextArea.current.style.height = `${returnTextArea.current.scrollHeight}px`
        }
        bottomOfMessages.current.scrollTop = bottomOfMessages.current.scrollHeight;
    }, [action.returnText.value, action.talk.value]);

    const handleRemove = (item) => {
        let last = action.talk.value[action.talk.value.length-1]
        if (last && last.role === 'user' && !action.submit.value){
            action.sendText.set(last.content)
        }
        action.talk.set((prev) => [...prev.filter((i) => i !== item && i !== last)]);
    };

    const handleRemove2 = (item) => {
        action.returnText.set('');
    };

    const handleSystemAreaClick = () => {
        if (systemTextArea.current) {
            systemTextArea.current.focus();
        }
      }

      const handleSendTextAreaClick = () => {
        if (sendTextArea.current) {
            sendTextArea.current.focus();
        }
      }

      const handleReturnTextAreaClick = () => {
        
        if (returnTextArea.current) {
            returnTextArea.current.focus();
        }
      }

      const handlerHelp = (type) => {
        let h = {...help}
        if (type === 1){
            h.title = "Shape Your Chatbot's Identity"
            h.open = true
            h.top = 250
            h.left = 500
        }
        else if (type === 2){
            h.title = "Navigating Your Saved Chats"
            h.open = true
            h.top = 220
            h.left = 755
        }
        else if (type === 3){
            h.title = 'Preserve your progress with "Save Chat"'
            h.open = true
            h.top = 220
            h.left = 855
        }

        h.type = type
        h.open = true
        setHelp(h)
      }

      const saveChat = () => {
        action.postSaveChat.set()
      }
      
      const hiddenFileInput = useRef(null)

      const [hidePlaceholder, setHidePlaceholder] = useState(false)
      const handleUploadImage = (event) => {
        const [file] = event.target.files
        if (file) action.imageUploaded.set(file)
    }

      const changeSavedChats = (e) =>{
        let chat = action.saveChat.value.filter(i => i.id === e.target.value)[0]
        if (chat?.name === 'New Chat'){
            e.preventDefault()
            action.saveChatName.set('')
            action.returnText.set('')
            action.saveChatSelected.set('')
            action.system.set(chat.system)
            action.talk.set([])

        }
        else if (chat?.id > 0){
            action.saveChatName.set(chat.name)
            action.system.set(chat.system)
            action.talk.set(chat.messages)
            action.saveChatSelected.set(chat.id)
        }
        
      }

      const renderHelp = () => {

        if (help.type === 1){
            return (
                <Box>
                    <MyLabel component='p' text="In this section, you have the power to mold the chatbot's role and personality." />
                    <p>
                        {intl.formatMessage({ id: "Be it"})} {' '}
                        <span style={{fontWeight:'bold'}}>"{intl.formatMessage({ id: "You are an expert lawyer" })}"</span> 
                        {' '}
                        {intl.formatMessage({ id: " or "})}
                        {' '}
                        <span style={{fontWeight:'bold'}}>"{intl.formatMessage({ id: "You are a sarcastic and creative AI assistant" })}"</span>
                        {' '}
                        {intl.formatMessage({ id: ", the choice is entirely yours. Remember, a well-customized chatbot enhances AI engagement."})}
                    </p>
                    <MyLabel component='p' text="Let's breathe life into your chatbot!" />
                </Box>
            )
        }
        else if (help.type === 2){
            return (
                <Box>
                    <p>
                        {intl.formatMessage({ id: "In the"})} {' '}
                        <span style={{fontWeight:'bold'}}>"{intl.formatMessage({ id: "Saved Chats" })}"</span> 
                        {' '}
                        {intl.formatMessage({ id: "section, you’ll find all of your chatbot interactions that you’ve chosen to save. Whether you want to review a particularly successful conversation or pick up where you left off, it’s all here."})}
                    </p>
                    <MyLabel component='p' text="Simply click on a chat to view it in detail. You can easily switch between different saved chats as per your need." />
                    <br />
                    <MyLabel component='p' text="So, go ahead, leap back into your past conversations and make the most of this handy resource!" />
                </Box>
            )
        }
        else if (help.type === 3){
            return (
                <Box>
                    <MyLabel component='p' text="Found a chat you’d like to revisit or learn from?" />
                    <p>
                        {intl.formatMessage({ id: "By clicking on the"})} {' '}
                        <span style={{fontWeight:'bold'}}>"{intl.formatMessage({ id: "Save Chat" })}"</span> 
                        {' '}
                        {intl.formatMessage({ id: "button, you can easily store the current chatbot interaction for future reference."})}
                    </p>
                    <MyLabel component='p' text='Once saved, you can locate these chats in the "Saved Chats" section. This feature allows you to review your past conversations whenever you like, making it easier to track your progress and improve your chatbot’s performance.' />
                    <br />
                    <MyLabel component='p' text="Remember, every interaction is a learning opportunity, so don’t hesitate to save!" />
                </Box>
            )
        }

        return <></>

      }

    return (
        <Box sx={{
        width:'100%',
        display:'flex', 
        flexDirection:'column', 
        marginTop:'0',
        gap: '16px',
        padding: '10px 20px',
        backgroundColor: '#FFFFFF',
        height: 'calc(100vh - 80px)',
        maxHeight: 'calc(100vh - 80px)',
        overflow: 'hidden',
        '@media (max-width: 600px)': {
            flexDirection:'column', 
            width: '100%',
            height: 'calc(100vh - 60px)',
        }}}>
            <Dialog 
                open={identityModalOpen} 
                onClose={() => setIdentityModalOpen(false)}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '16px',
                        padding: '8px',
                    }
                }}
            >
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pb: 1 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: '18px', color: '#333' }}>
                        {identityModalMode === 'edit' ? 'Modifica Identità' : 'Nuova Identità'}
                    </Typography>
                    <IconButton onClick={() => setIdentityModalOpen(false)} size="small">
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px', pt: 1 }}>
                        <input
                            type="text"
                            placeholder="Nome dell'identità..."
                            value={identityModalName}
                            onChange={(e) => setIdentityModalName(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '12px 16px',
                                fontSize: '14px',
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                outline: 'none',
                            }}
                        />
                        <textarea 
                            placeholder="Descrivi la personalità e le competenze del tuo assistente..."
                            value={identityModalPrompt}
                            onChange={(e) => setIdentityModalPrompt(e.target.value)}
                            style={{
                                width: '100%',
                                padding: '14px 16px',
                                fontSize: '14px',
                                border: '1px solid #e0e0e0',
                                borderRadius: '12px',
                                outline: 'none',
                                resize: 'none',
                                height: '180px',
                                fontFamily: 'inherit',
                                lineHeight: '1.6',
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px', gap: '8px' }}>
                    <MyButton
                        text="Annulla"
                        variant="outlined"
                        size="small"
                        onClick={() => setIdentityModalOpen(false)}
                        sx={{
                            borderRadius: '12px',
                            borderColor: '#ccc',
                            color: '#666',
                        }}
                    />
                    <MyButton
                        text={identityModalMode === 'edit' ? 'Salva modifiche' : 'Crea identità'}
                        variant="contained"
                        size="small"
                        onClick={handleIdentityModalSave}
                        sx={{
                            backgroundColor: '#00a271',
                            borderRadius: '12px',
                            ':hover': {
                                backgroundColor: '#11B382',
                            },
                        }}
                    />
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={confirmChatChangeOpen}
                onClose={() => setConfirmChatChangeOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '24px',
                        maxWidth: '380px',
                        width: '100%',
                        overflow: 'hidden',
                    }
                }}
            >
                <Box sx={{
                    background: 'linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)',
                    padding: '28px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '10px',
                }}>
                    <Box sx={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255,255,255,0.25)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <HistoryIcon sx={{ fontSize: '28px', color: '#FFF' }} />
                    </Box>
                    <Typography sx={{ 
                        fontWeight: 700, 
                        fontSize: '20px', 
                        color: '#FFF',
                        textAlign: 'center',
                    }}>
                        Conversazione in corso
                    </Typography>
                </Box>
                <DialogContent sx={{ textAlign: 'center', padding: '24px' }}>
                    <Typography sx={{ color: '#333', fontSize: '15px', lineHeight: 1.6 }}>
                        Hai una conversazione non salvata. Cambiando assistente perderai tutti i messaggi.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '0 24px 24px', gap: '10px', flexDirection: 'column' }}>
                    <MyButton
                        text="Salva e avvia nuova chat"
                        variant="contained"
                        size="medium"
                        fullWidth
                        onClick={handleSaveAndStartNewChat}
                        sx={{
                            background: 'linear-gradient(135deg, #00a271 0%, #11B382 100%)',
                            borderRadius: '14px',
                            padding: '12px',
                            fontSize: '14px',
                            fontWeight: 600,
                            boxShadow: '0 4px 14px rgba(0,162,113,0.3)',
                            ':hover': {
                                background: 'linear-gradient(135deg, #11B382 0%, #22C493 100%)',
                            },
                        }}
                    />
                    <MyButton
                        text="Avvia senza salvare"
                        variant="outlined"
                        size="medium"
                        fullWidth
                        onClick={confirmStartNewChat}
                        sx={{
                            borderRadius: '14px',
                            padding: '12px',
                            fontSize: '14px',
                            borderColor: '#ddd',
                            color: '#666',
                            ':hover': {
                                borderColor: '#bbb',
                                backgroundColor: '#fafafa',
                            }
                        }}
                    />
                    <MyButton
                        text="Annulla"
                        variant="text"
                        size="small"
                        onClick={() => setConfirmChatChangeOpen(false)}
                        sx={{
                            color: '#888',
                            fontSize: '13px',
                            ':hover': {
                                backgroundColor: 'transparent',
                                color: '#666',
                            }
                        }}
                    />
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={deleteConfirmOpen}
                onClose={() => setDeleteConfirmOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '20px',
                        maxWidth: '380px',
                        width: '100%',
                    }
                }}
            >
                <DialogTitle sx={{ fontWeight: 600, fontSize: '18px', paddingBottom: '8px' }}>
                    Conferma eliminazione
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{ color: '#666', fontSize: '14px' }}>
                        Sei sicuro di voler eliminare questa identità? L'azione non può essere annullata.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '16px 24px', gap: '8px' }}>
                    <MyButton
                        text="Annulla"
                        variant="outlined"
                        size="small"
                        onClick={() => setDeleteConfirmOpen(false)}
                        sx={{
                            borderRadius: '12px',
                            borderColor: '#ccc',
                            color: '#666',
                        }}
                    />
                    <MyButton
                        text="Elimina"
                        variant="contained"
                        size="small"
                        onClick={confirmDeleteIdentity}
                        sx={{
                            backgroundColor: '#d32f2f',
                            borderRadius: '12px',
                            ':hover': {
                                backgroundColor: '#b71c1c',
                            },
                        }}
                    />
                </DialogActions>
            </Dialog>
            
            <Dialog
                open={upgradeModalOpen}
                onClose={() => setUpgradeModalOpen(false)}
                PaperProps={{
                    sx: {
                        borderRadius: '24px',
                        maxWidth: '380px',
                        width: '100%',
                        overflow: 'hidden',
                    }
                }}
            >
                <Box sx={{
                    background: 'linear-gradient(135deg, #702180 0%, #9c4dcc 100%)',
                    padding: '32px 24px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                }}>
                    <Box sx={{
                        width: '64px',
                        height: '64px',
                        borderRadius: '50%',
                        backgroundColor: 'rgba(255,255,255,0.2)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        <BoltIcon sx={{ fontSize: '32px', color: '#FFF' }} />
                    </Box>
                    <Typography sx={{ 
                        fontWeight: 700, 
                        fontSize: '22px', 
                        color: '#FFF',
                        textAlign: 'center',
                    }}>
                        Limite raggiunto
                    </Typography>
                </Box>
                <DialogContent sx={{ textAlign: 'center', padding: '24px' }}>
                    <Typography sx={{ color: '#333', fontSize: '15px', marginBottom: '12px', fontWeight: 500 }}>
                        Hai raggiunto il limite di {planLimits[userPlan]} assistenti
                    </Typography>
                    <Typography sx={{ color: '#888', fontSize: '14px', lineHeight: 1.6 }}>
                        Passa a un piano superiore per sbloccare più assistenti personalizzati e funzionalità avanzate.
                    </Typography>
                </DialogContent>
                <DialogActions sx={{ padding: '0 24px 24px', gap: '12px', flexDirection: 'column' }}>
                    <MyButton
                        text="Fai upgrade ora"
                        variant="contained"
                        size="medium"
                        fullWidth
                        onClick={() => {
                            setUpgradeModalOpen(false);
                        }}
                        sx={{
                            background: 'linear-gradient(135deg, #702180 0%, #9c4dcc 100%)',
                            borderRadius: '14px',
                            padding: '12px',
                            fontSize: '15px',
                            fontWeight: 600,
                            boxShadow: '0 4px 14px rgba(112,33,128,0.3)',
                            ':hover': {
                                background: 'linear-gradient(135deg, #8a2a9e 0%, #b366d9 100%)',
                                boxShadow: '0 6px 20px rgba(112,33,128,0.4)',
                            },
                        }}
                    />
                    <MyButton
                        text="Magari dopo"
                        variant="text"
                        size="small"
                        onClick={() => setUpgradeModalOpen(false)}
                        sx={{
                            color: '#888',
                            fontSize: '13px',
                            ':hover': {
                                backgroundColor: 'transparent',
                                color: '#666',
                            }
                        }}
                    />
                </DialogActions>
            </Dialog>
            
            <Box 
                sx={{
                    backgroundColor: '#FFF',
                    borderRadius: '16px',
                    border: '1px solid #e8e8e8',
                    overflow: 'hidden',
                    transition: 'all 0.3s ease',
                    flexShrink: 0,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                }}
            >
                <Box 
                    onClick={() => setIdentityExpanded(!identityExpanded)}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '14px 20px',
                        cursor: 'pointer',
                        backgroundColor: '#FFF',
                        transition: 'all 0.2s ease',
                    }}
                >
                    <Box sx={{display: 'flex', alignItems: 'center', gap: '12px'}}>
                        <img src={robotIcon} alt="robot" style={{ width: '28px', height: '28px' }} />
                        <Box>
                            {!identityExpanded && selectedIdentity !== null ? (
                                <>
                                    <Typography sx={{ fontWeight: 600, color: '#333', fontSize: '15px' }}>
                                        Stai chattando con: <span style={{ color: '#00a271' }}>{savedIdentities.find(i => i.id === selectedIdentity)?.name || 'Assistente'}</span>
                                    </Typography>
                                    <Typography sx={{ color: '#888', fontSize: '12px', marginTop: '2px' }}>
                                        Clicca per cambiare identità
                                    </Typography>
                                </>
                            ) : (
                                <>
                                    <Typography sx={{ fontWeight: 600, color: '#333', fontSize: '15px' }}>
                                        Dai un'identità al tuo Chat Assistant
                                    </Typography>
                                    <Typography sx={{ color: '#888', fontSize: '12px', marginTop: '2px' }}>
                                        Scegli chi vuoi che sia il tuo interlocutore oggi.
                                    </Typography>
                                </>
                            )}
                        </Box>
                    </Box>
                    <IconButton size="small" sx={{ color: '#00a271' }}>
                        {identityExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                </Box>
                <Collapse in={identityExpanded}>
                    <Box sx={{ padding: '16px 20px', display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
                        {savedIdentities.map((identity) => (
                            <Box
                                key={identity.id}
                                sx={{
                                    width: '220px',
                                    padding: '16px',
                                    borderRadius: '16px',
                                    backgroundColor: selectedIdentity === identity.id ? 'rgba(0,162,113,0.08)' : '#FFF',
                                    border: selectedIdentity === identity.id ? '1px solid #00a271' : '1px solid #e0e0e0',
                                    boxShadow: selectedIdentity === identity.id ? 'none' : '0 2px 6px rgba(0,0,0,0.06)',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '8px',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: selectedIdentity === identity.id ? 'rgba(0,162,113,0.12)' : '#fafafa',
                                    }
                                }}
                                onClick={() => {
                                    setSelectedIdentity(identity.id);
                                    action.system.set(identity.prompt);
                                }}
                            >
                                <Typography sx={{ 
                                    fontSize: '15px', 
                                    fontWeight: 600, 
                                    color: '#333' 
                                }}>
                                    {identity.name}
                                </Typography>
                                <Typography sx={{ 
                                    fontSize: '12px', 
                                    color: '#666',
                                    lineHeight: 1.4,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: '-webkit-box',
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: 'vertical',
                                }}>
                                    {identity.prompt.substring(0, 80)}...
                                </Typography>
                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
                                    <Box sx={{ display: 'flex', gap: '4px' }}>
                                        <IconButton 
                                            size="small" 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                openIdentityModal('edit', identity);
                                            }}
                                            sx={{ 
                                                padding: '4px',
                                                color: '#888',
                                            }}
                                        >
                                            <EditIcon sx={{ fontSize: '16px' }} />
                                        </IconButton>
                                        {!identity.isDefault && (
                                            <IconButton 
                                                size="small" 
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleDeleteIdentity(identity.id);
                                                }}
                                                sx={{ 
                                                    padding: '4px',
                                                    color: '#888',
                                                }}
                                            >
                                                <DeleteIcon sx={{ fontSize: '16px' }} />
                                            </IconButton>
                                        )}
                                    </Box>
                                    {selectedIdentity === identity.id && (
                                        <Box 
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleStartChat(identity);
                                            }}
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '4px',
                                                padding: '4px 10px',
                                                borderRadius: '8px',
                                                backgroundColor: '#00a271',
                                                cursor: 'pointer',
                                                '&:hover': {
                                                    backgroundColor: '#11B382',
                                                }
                                            }}
                                        >
                                            <PlayArrowIcon sx={{ fontSize: '14px', color: '#FFF' }} />
                                            <Typography sx={{ fontSize: '11px', fontWeight: 600, color: '#FFF', textTransform: 'uppercase' }}>
                                                Avvia chat
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        ))}
                        <Box
                            onClick={() => openIdentityModal('create')}
                            sx={{
                                width: '220px',
                                padding: '16px',
                                borderRadius: '16px',
                                border: '1px dashed #ccc',
                                borderSpacing: '20px',
                                backgroundColor: '#FFF',
                                cursor: 'pointer',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                minHeight: '120px',
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                    borderColor: '#702180',
                                    backgroundColor: '#faf5fb',
                                }
                            }}
                        >
                            <AddIcon sx={{ fontSize: '28px', color: '#999' }} />
                            <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#666', textTransform: 'uppercase', textAlign: 'center' }}>
                                Nuova Identità
                            </Typography>
                        </Box>
                    </Box>
                </Collapse>
            </Box>
            <Box sx={{
                width:'100%',
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                minHeight: 0,
                '@media (max-width: 600px)': {
                    marginTop:'10px', 
                }}}>
                <Box ref={modelButtonsRef} sx={{display:'flex', justifyContent:'space-between', alignItems: 'center', marginBottom:'12px', width:'100%', flexWrap: 'wrap', gap: '12px', flexShrink: 0}}>
                    <Box sx={{
                        display: 'flex',
                        gap: '8px',
                        transition: 'all 0.3s ease',
                    }}>
                        {isScrolledDown ? (
                            <Box
                                onClick={() => {
                                    if (bottomOfMessages.current) {
                                        bottomOfMessages.current.scrollTop = 0;
                                    }
                                }}
                                sx={{
                                    padding: '6px 14px',
                                    borderRadius: '12px',
                                    border: '1px solid #00a271',
                                    backgroundColor: 'transparent',
                                    cursor: 'pointer',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        backgroundColor: 'rgba(0,162,113,0.05)',
                                    }
                                }}
                            >
                                {React.createElement(aiModels[selectedModel].icon, { sx: { fontSize: '16px', color: '#00a271' } })}
                                <Typography
                                    sx={{
                                        color: '#00a271',
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        whiteSpace: 'nowrap',
                                    }}
                                >
                                    {aiModels[selectedModel].name}
                                </Typography>
                            </Box>
                        ) : (
                            aiModels.map((model) => {
                                const IconComponent = model.icon;
                                const isSelected = selectedModel === model.id;
                                return (
                                <Box
                                    key={model.id}
                                    onClick={() => {
                                        setSelectedModel(model.id);
                                        action.mini.set(model.id === 2);
                                    }}
                                    sx={{
                                        padding: '10px 16px',
                                        borderRadius: '12px',
                                        backgroundColor: isSelected ? model.color : 'transparent',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: isSelected ? model.color : 'rgba(0,0,0,0.05)',
                                        }
                                    }}
                                >
                                    <IconComponent sx={{ 
                                        fontSize: '18px', 
                                        color: isSelected ? '#FFF' : '#666' 
                                    }} />
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                        <Typography
                                            sx={{
                                                color: isSelected ? '#FFF' : '#333',
                                                fontSize: '14px',
                                                fontWeight: 600,
                                                whiteSpace: 'nowrap',
                                                lineHeight: 1.2,
                                            }}
                                        >
                                            {model.name}
                                        </Typography>
                                        {model.subtitle && (
                                            <Typography
                                                sx={{
                                                    color: isSelected ? 'rgba(255,255,255,0.8)' : '#999',
                                                    fontSize: '10px',
                                                    fontWeight: 500,
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.03em',
                                                }}
                                            >
                                                {model.subtitle}
                                            </Typography>
                                        )}
                                    </Box>
                                </Box>
                            );
                            })
                        )}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <SavedChatsSelect 
                            id='saved_chats'
                            label='Saved Chats'
                            options={action.saveChat.value}
                            size='small'
                            value={action.saveChatSelected.value}
                            onChange={changeSavedChats}
                        />
                        <MyButton 
                            disabled={action.submit.value}
                            onClick={() => {
                                setDialogOpen(true);
                            }}
                            text='SALVA CHAT'
                            variant="contained"
                            size="small"
                            sx={{
                                backgroundColor: '#00a271',
                                borderRadius: '12px',
                                padding: '10px 20px',
                                whiteSpace: 'nowrap',
                                minWidth: 'auto',
                                fontWeight: 600,
                                fontSize: '13px',
                                letterSpacing: '0.02em',
                                ':hover':{
                                    backgroundColor: '#11B382',
                                },
                            }}
                        />
                    </Box>
                </Box>
                <Box sx={style.messageContainer} ref={bottomOfMessages}>
                    {
                        action.talk.value.map((t, k) => {
                        
                        return <MessageArea key={k} message={t} handleRemove ={handleRemove} last={k===action.talk.value.length-1} />
                    
                    })
                    }
                    {
                        action.returnText.value !== '' ?
                            <Fade in={true} timeout={500} >
                                <Box onClick={handleReturnTextAreaClick} sx={{
                                    ...style.messageArea, 
                                    backgroundColor: '#FFF', 
                                    border: returnTextAreaFocus?'2px solid #00a271': 'none'
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'row',
                                        alignItems:'center',
                                        alignContent: 'center',
                                        marginBottom: '10px',
                                    }}>
                                        <Box sx={{...style.messageTitleArea, justifyContent: 'start'}}>
                                            <MyLabel component='p' text={'AI'} 
                                            sx={{...style.title, color: '#00a271'}} />
                                        </Box>
                                        <Box  sx={{
                                            display: 'flex',
                                            alignItems:'center',
                                            alignContent: 'center',
                                            }}>
                                            <RemoveCircleOutlineIcon onClick={() => handleRemove2('')} sx={{ color: '#a3a3a3', cursor: 'pointer' }} />
                                        </Box>
                                    </Box>
                                    <textarea 
                                        ref={returnTextArea}
                                        onFocus={onFocusReturnText}
                                        onBlur={onBlurReturnText}

                                        style={{
                                            width:'100%',
                                            border:'none',
                                            outline: "none", 
                                            resize: "none",
                                            backgroundColor: '#FFF',
                                            fontSize: '12pt',
                                            '@media (max-width: 600px)': {height:'300px'}
                                        }} 
                                        value={action.returnText.value} 
                                        onChange={(e)=>{
                                            action.returnText.set(e.target.value)
                                            returnTextArea.current.style.height = '80px';
                                            if (returnTextArea.current){
                                                returnTextArea.current.style.height = `${returnTextArea.current.scrollHeight}px`
                                            }
                                        }}
                                    />
                                </Box>
                            </Fade>

                        :
                        null
                    }
                </Box>
                <Box sx={{display:'flex', flexDirection:'column', flexShrink: 0, paddingBottom: '20px'}}>
                    <Fade in={true} timeout={500}>
                        <Box onClick={handleSendTextAreaClick} sx={{
                            ...style.sendArea,
                            border: '1px solid #e0e0e0',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography sx={{ fontWeight: 600, color: '#666', fontSize: '12px', textTransform: 'uppercase' }}>
                                    {intl.formatMessage({ id: "YOU" })}
                                </Typography>
                                <Box 
                                    onClick={(e) => { e.stopPropagation(); hiddenFileInput.current.click(); }}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '36px',
                                        height: '36px',
                                        borderRadius: '10px',
                                        backgroundColor: '#f5f5f5',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        '&:hover': {
                                            backgroundColor: '#e8e8e8',
                                        }
                                    }}
                                >
                                    <AttachFileIcon sx={{ color: '#666', fontSize: '20px', transform: 'rotate(45deg)' }} />
                                </Box>
                            </Box>
                            {action.imageUploaded.value && (
                                <Box sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: '8px',
                                    padding: '8px',
                                    backgroundColor: '#f0f7ff',
                                    borderRadius: '12px',
                                }}>
                                    <MyImage src={URL.createObjectURL(action.imageUploaded.value)} sx={{ width:'60px', height:'60px', borderRadius: '8px', objectFit: 'cover' }} />
                                    <Typography sx={{ fontSize: '12px', color: '#666' }}>Image attached</Typography>
                                </Box>
                            )}
                            <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '12px' }}>
                                <textarea 
                                    ref={sendTextArea}
                                    onFocus={onFocusSendText}
                                    onBlur={onBlurSendText}
                                    placeholder={intl.formatMessage({ id: "Enter a message here." })}
                                    disabled={action.submit.value}
                                    style={{
                                        width: '100%',
                                        border: 'none',
                                        outline: 'none', 
                                        resize: 'none',
                                        fontSize: '14px',
                                        minHeight: '60px',
                                        fontFamily: 'inherit',
                                        lineHeight: '1.5',
                                        backgroundColor: 'transparent',
                                        flex: 1,
                                        opacity: action.submit.value ? 0.6 : 1,
                                    }} 
                                    value={action.sendText.value} 
                                    onChange={(e) => {
                                        action.sendText.set(e.target.value)
                                        if (sendTextArea.current){
                                            if (sendTextArea.current.scrollHeight > 80 && sendTextArea.current.scrollHeight <= 213){
                                                sendTextArea.current.style.height = `${sendTextArea.current.scrollHeight}px`
                                            }
                                            else if (sendTextArea.current.scrollHeight > 213){
                                                sendTextArea.current.style.height = `213px`
                                            }
                                        }
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' && !e.shiftKey) {
                                            e.preventDefault();
                                            if (action.sendText.value?.trim() && !action.submit.value) {
                                                action.submit.set(updateHistoric);
                                            }
                                        }
                                    }}
                                />
                                <IconButton
                                    onClick={async (e) => {
                                        e.stopPropagation();
                                        if (action.submit.value) {
                                            handlerCancel();
                                        } else if (action.sendText.value?.trim()) {
                                            action.submit.set(updateHistoric);
                                        }
                                    }}
                                    disabled={!action.submit.value && !action.sendText.value?.trim()}
                                    sx={{
                                        width: '44px',
                                        height: '44px',
                                        borderRadius: '50%',
                                        backgroundColor: action.submit.value 
                                            ? '#ef4444' 
                                            : action.sendText.value?.trim() 
                                                ? '#702180' 
                                                : '#d1d5db',
                                        color: '#FFF',
                                        transition: 'all 0.2s ease',
                                        flexShrink: 0,
                                        '&:hover': {
                                            backgroundColor: action.submit.value 
                                                ? '#dc2626' 
                                                : action.sendText.value?.trim() 
                                                    ? '#8B2A9E' 
                                                    : '#d1d5db',
                                        },
                                        '&.Mui-disabled': {
                                            backgroundColor: '#d1d5db',
                                            color: '#FFF',
                                        }
                                    }}
                                    data-testid="button-send-chat"
                                >
                                    {action.submit.value ? (
                                        <CircularProgress size={20} sx={{ color: '#FFF' }} />
                                    ) : (
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                            <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    )}
                                </IconButton>
                            </Box>
                            <input style={{ display: 'none' }} onChange={handleUploadImage} ref={hiddenFileInput} type='file' accept='image/*' />
                        </Box>
                    </Fade>
                </Box>
            </Box>
            <MyPanelHelp 
                title = {help.title}
                open = {help.open}
                onClose = {()=>{
                    let h = {...help}
                    h.open = false
                    setHelp(h)
                }}
                top = {help.top}
                left = {help.left} >
                {renderHelp()}
            </MyPanelHelp>
            <MessageDialog name={action.saveChatName} open={dialogOpen} handleClose={()=>setDialogOpen(false)} handleSuccess={saveChat} />
        </Box>
    );
}

export default Chat;
